module.exports = __webpack_public_path__ + "img/housou01.db4d11fb.png";